<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Equipment Item', apiMethod: 'EquipmentItems', form: () => import('../forms/EquipmentItemForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Calibration', apiMethod: 'Calibrations', parentForeignKey: 'equipmentItemId', form: () => import('../forms/CalibrationForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Calibrations', value: 'equipmentItemId', isCard: true, table: () => import('../tables/CalibrationsTable') },
                ],
                mainForm: () => import('../forms/EquipmentItemForm'),
                claimName: 'EquipmentItems',
                apiMethod: 'EquipmentItems',
            }
        }
    };
</script>
